import React from "react"
import ReactDOM from "react-dom"
import LocalStorageComponent from "./LocalStorageComponent"

ReactDOM.render(
  <React.StrictMode>
    <LocalStorageComponent />
  </React.StrictMode>,
  document.getElementById("root")
)
